/**
 * 作品库
 */

import * as React from 'react'
import { Button } from 'antd'
import classNames from 'classnames'
import gioTrackEvent from '@/utils/gio'
import eventMap from '@/utils/gio/eventMap'
import styles from './index.module.less'

const { useState, useMemo } = React

export default function Tutorial({ dataSource, onCancel, t }: any) {
  const [current, setCurrent] = useState<any>(0)
  const [autoPlay, setAutoPlay] = useState(false)

  const lastIndex: number = useMemo(() => {
    if (dataSource.length > 0) {
      return dataSource.length - 1
    }
    return 0
  }, [dataSource])
  const currentItem: any = dataSource[current] || {}

  /**
   * 下一步
   */
  const handleNext = () => {
    if (current < lastIndex) {
      const nextIdx = current + 1
      const nextItem = dataSource[current] || {}
      setAutoPlay(true)
      setCurrent(nextIdx)
      gioTrackEvent(eventMap.works_course_videoview_click, { videoid: nextItem.text })
    }
  }

  /**
   * 切换
   */
  const handleChange = (index: number) => {
    if (index === current) return
    const nextItem = dataSource[index] || {}
    setAutoPlay(true)
    setCurrent(index)
    gioTrackEvent(eventMap.works_course_videoview_click, { videoid: nextItem.text })
  }

  /**
   * 渲染按钮
   * @returns
   */
  const renderButton = () => {
    if (currentItem?.id === dataSource?.[lastIndex]?.id) {
      return (
        <Button type="primary" onClick={onCancel}>
          {t('components:t106')}
        </Button>
      )
    }
    return (
      <Button type="primary" onClick={handleNext}>
        {t('components:t107')}
      </Button>
    )
  }

  return (
    <div className={styles.tutorial}>
      <div className={styles.side}>
        {dataSource.map((item: any, index: number) => (
          <div
            key={item.id}
            className={classNames(styles['menu-item'], {
              [styles.active]: currentItem.id === item.id,
            })}
            onClick={() => handleChange(index)}
          >
            <div className={styles.wrap}>
              <img src={item.thumbnail} alt="" />
            </div>
            <div className={styles.txt}>{item.text}</div>
          </div>
        ))}
      </div>
      <div className={styles.main}>
        <div className={styles.section}>
          {currentItem.src && (
            <video
              poster={currentItem.poster}
              src={currentItem.src}
              autoPlay={autoPlay}
              controls
              // loop
            />
          )}
        </div>
        <div className={styles.footer}>{dataSource.length > 0 && renderButton()}</div>
      </div>
    </div>
  )
}
